import type { FaireProductEntity } from "../../entity_types/product";

export const p_cd3x9de5at: FaireProductEntity = {
  token: "p_cd3x9de5at",
  type: "product",
  name: "Golden Hour 12 oz Soy Candle - Home Decor & Summer Gifts",
  brandToken: "b_qctjfrupd6",
  brandName: "Rustic Rays Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/a2cb8437f1283a18ef8300d6e4bf65249cd3bce6e213ddb018467cacf32f22ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/960e36e4a4c24dad7d7c8e196636e6e4b29ce852f4792f082c74f5f163f92f1b.jpeg",
    "https://cdn.faire.com/fastly/a5de38cd85cb2f6bfa922535b5bf2c65b839f0fe49abcba6590500db964e230c.png",
    "https://cdn.faire.com/fastly/7f4072aa31d3e9432506c705eda608d9d86b654f00c03599da569d2cc76dfc0d.png",
  ],
  priceDollars: 12.95,
  description:
    "GOLDEN HOUR FRAGRANCE NOTES\nMandarin / Peach / Jasmine / Vanilla / Tonka Bean\n\nOur Golden Hour soy candle gives you the relaxing feeling of watching the sunset during a warm Summer evening. Cozy notes of sandalwood and tonka bean fill the air while the last of the days sun is shinning down on you. A breeze rolls through bringing with it lighter smells of distant citrus and florals.\n\nOur signature matte black vessels hold two wicks with superior scent, making them extremely popular.\n\nCANDLE DETAILS\n• Net Wt. 12 oz (340 g)\n• 55+ Hour Burn Time\n• 100% Soy Wax\n• Cotton Wicks (Lead Free & Zinc Free)\n• Premium Fragrance Oils (Phthalate-Free, Paraben-Free, Vegan-Friendly)\n• Matte Black Tin (4 W” x 2.75 H”)\n• Hand Poured in Illinois, USA\n\nLuxury Home Fragrance, Boutique Candles, Clean Burning Soy Candles, Hand Poured Candles, Modern Home Decor, Elevated Home Fragrance, Summer Inspired Scents, Coastal Home Decor, Boutique Gift Shop, Hotel Inspired Candles, Summer Boutique Finds, Contemporary Home Decor, Clean Ingredient Candles, Artisan Candle Brand",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:58.885Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
